/**
 * Mesure le logo de l'en-tête pour caler la gouttière centrale du menu réparti.
 *
 * La valeur est écrite dans une balise <style> dédiée plutôt qu'en style inline :
 * Horizon réécrit l'attribut style de <html> et re-rend l'en-tête après
 * hydratation. Le découpage du menu, lui, est purement CSS (amber-header.css),
 * qui porte aussi une valeur de repli si ce script ne tourne pas.
 */
(() => {
  const BREAKPOINT = 990;
  const BREATHING_ROOM = 72; // respiration de part et d'autre du logo

  let styleTag = null;
  let lastValue = null;

  const SPLIT_AFTER = 3; // doit suivre le nth-child d'amber-header.css

  const apply = () => {
    const logo = document.querySelector('.header__columns .header-logo');
    const list = document.querySelector('.header__columns .header-menu .overflow-menu');
    if (!logo || !list || window.innerWidth < BREAKPOINT) return;

    const gap = Math.round(logo.getBoundingClientRect().width) + BREATHING_ROOM;
    if (gap <= BREATHING_ROOM) return;

    // Les deux moitiés du menu n'ont pas la même largeur : sans compensation,
    // la gouttière — et donc le logo — se décale de la moitié de l'écart.
    const links = [...list.children].filter((li) => li.querySelector('a[href]'));
    if (links.length <= SPLIT_AFTER) return;

    // L'espace inter-liens compte dans la largeur d'une moitié : les deux
    // groupes n'ont pas le même nombre d'intervalles.
    const spacing = links.length > 1
      ? links[1].getBoundingClientRect().left - links[0].getBoundingClientRect().right
      : 0;
    const width = (items) =>
      items.reduce((total, li) => total + li.getBoundingClientRect().width, 0) +
      Math.max(0, items.length - 1) * spacing;

    const left = width(links.slice(0, SPLIT_AFTER));
    const right = width(links.slice(SPLIT_AFTER));
    const offset = Math.round(right - left);

    const value = `${gap}|${offset}`;
    if (value === lastValue) return;
    lastValue = value;

    if (!styleTag) {
      styleTag = document.createElement('style');
      styleTag.id = 'ag-logo-gap';
      document.head.appendChild(styleTag);
    }

    // On décale la liste plutôt que d'ajouter une marge : une marge
    // consommerait de la largeur et l'overflow-list replierait un lien
    // dans son menu « Plus ». Un translate ne change pas le layout.
    styleTag.textContent =
      `:root{--ag-logo-gap:${gap}px}` +
      `#header-component .header__column--right .header-menu .overflow-menu` +
      `{transform:translateX(${Math.round(offset / 2)}px)}`;
  };

  /* Pas de requestAnimationFrame ici : il reste suspendu tant que l'onglet
     n'est pas visible, et la gouttière ne serait jamais calée. */
  const schedule = () => {
    apply();
    setTimeout(apply, 0);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedule, { once: true });
  } else {
    schedule();
  }
  window.addEventListener('resize', schedule);
  window.addEventListener('load', schedule);
  document.addEventListener('shopify:section:load', schedule);
  if (document.fonts) document.fonts.ready.then(schedule);
})();
